/*******************************************************************************
 * $Id: Organization.js 20552 2020-11-28 21:48:55Z sthames $ */
/**
 * @ngdoc    object
 * @module   csm.books.data
 * @name     csm.books.data.BooksData.type:EntityInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Entity information. Mirrors `csm.booksdb.data.EntityInfo`.
 *******************************************************************************/
/* @ngInject */ export function organizationConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'Data.books.entities.Organization',
    inherits: 'Data.books.EntityInfo',
    $type: 'csm.booksdb.data.entities.Organization, CSMBooksDBCS',
    prototype: {
      commonID: 0, // Common ID.
      orgType: null, // Organization Type.
      code: null, // Organization Code.
      fyMonth: 0, // Fiscal Year Start Month.
      fyDay: 0, // Fiscal Year Start Day.
      tyMonth: 0, // Tax Year Start Month.
      tyDay: 0, // Tax Year Start Day.
      taxForm: 0, // Tax Form.
      taxRate: 0, // Sales Tax Rate.
      allowSignatures: false, // Allow Signatures flag.
      defaultBankID: 0, // Default Bank Account ID.
      unitID: null, // PTA ONLY, Unit ID.
      nationalUnitID: null, // PTA ONLY, National Unit ID.
      stateID: null, // PTA ONLY, State ID (FTD).
      FEIN: null, // PTA ONLY, FEIN.
      exitGrade: 0, // Exit Grade.
      contractDate: null, // Contract Start Date.
      openDate: null // Books Opened Date.
    },
    constructor: function (Data) {
      return function (data) {
        Data.books.EntityInfo.call(this, data);
      };
    }
  });
};
